import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  FormBuilderService,
  ApplicationService,
  NotificationService,
  WorkbookService,
  CommunicationService,
  SalesService,
  ProductService,
  SubmissionService, TypesService
} from '../../services';
import {WizardFormComponent, WizardSteps} from './wizard-form.component';
import {BaseSubmissionModel} from '../../models/submission/base-submission-model';
import { UntypedFormArray, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {IndividualPersonModel} from '../../models/widgets/personal-details-model';
import {IndividualCompanyModel} from '../../models/widgets';
import {IndividualTrustModel} from '../../models/widgets/trust-details-model';
import {DomSanitizer} from '@angular/platform-browser';
import {OAuthService} from 'angular-oauth2-oidc';
import {Router, ActivatedRoute} from '@angular/router';
import {environment} from '../../../environments/environment';
import {LCA_ORIGINATOR_PARTY_ROLE_ID} from '../../_global/wiz.constants';
import * as _ from 'lodash';
import {debounceTime} from 'rxjs/operators';
import {DataHandlerService} from '../../services/data-handler.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { BrokerNotesComponent } from '../widgets/broker-notes/broker-notes.component';
import { ProductComponent } from '../widgets/product/product.component';
import { RateComponent } from '../widgets/rate/rate.component';
import { SolicitorBorrowerDetailsComponent } from '../widgets';
import { SolicitorPanelDetailsComponent } from '../widgets';
import { SecurityDetailsComponent } from '../widgets';
import { HomeLoanDetailsComponent } from '../widgets';
import { ApplicationTypeComponent } from '../widgets';
import { LoanDetailsTermsComponent } from '../widgets';
import { QuotesListComponent } from '../widgets';
import { QuoteDetailsComponent } from '../widgets';
import { ConfirmationComponent } from '../widgets/confirmation/confirmation.component';
import { SubmitComponent } from '../widgets/submit/submit.component';
import { DocumentUploadComponent } from '../widgets/documents-upload/documents-upload.component';
import { AutoCollateralComponent } from '../widgets/auto-collateral/auto-collateral.component';
import { ExpensesDetailsComponent } from '../widgets/expense-details/expenses-details.component';
import { LiabilitiesDetailsComponent } from '../widgets/liabilities-details/liabilities-details.component';
import { AssetsDetailsComponent } from '../widgets/assets-details/assets-details.component';
import { IncomeDetailsComponent } from '../widgets/income-details/income-details.component';
import { InvestmentIncomeComponent } from '../widgets/investment-income/investment-income.component';
import { BalloonAmountComponent } from '../widgets';
import { LoanTermsComponent } from '../widgets';
import { SingleSplitLoanAmountComponent } from '../widgets';
import { LoanDetailsComponent } from '../widgets';
import { BusinessCarLoanDetailsComponent } from '../widgets';
import { PersonalDetailsComponent } from '../widgets';
import { CompanyDetailsComponent } from '../widgets';
import { BorrowerTypeEnhancedComponent } from '../widgets/borrower-type-enhanced/borrower-type-enhanced.component';
import { BorrowerTypeComponent } from '../widgets';
import { AbnAcnComponent } from '../widgets';
import { CustomerDetailsComponent } from '../widgets';
import { OriginatorBrokerComponent } from '../widgets';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { NgClass, NgIf, NgFor } from '@angular/common';
import { MatSidenavModule } from '@angular/material/sidenav';
import {EmploymentDetailsComponent} from '../widgets/employment-details/employment-details.component';
import {TrustDetailsComponent} from '../widgets/trust-details/trust-details.component';

@Component({
    templateUrl: './wizard-form.component.html',
    standalone: true,
    imports: [MatSidenavModule, NgClass, MatProgressBarModule, NgIf, MatListModule, NgFor, MatButtonModule, MatButtonModule,
      FormsModule, OriginatorBrokerComponent, ReactiveFormsModule, CustomerDetailsComponent, AbnAcnComponent, BorrowerTypeComponent,
      BorrowerTypeEnhancedComponent, TrustDetailsComponent, CompanyDetailsComponent, PersonalDetailsComponent, BusinessCarLoanDetailsComponent,
      LoanDetailsComponent, SingleSplitLoanAmountComponent, LoanTermsComponent, BalloonAmountComponent, EmploymentDetailsComponent,
      InvestmentIncomeComponent, IncomeDetailsComponent, AssetsDetailsComponent, LiabilitiesDetailsComponent, ExpensesDetailsComponent,
      AutoCollateralComponent, DocumentUploadComponent, SubmitComponent, ConfirmationComponent, QuoteDetailsComponent, QuotesListComponent,
      LoanDetailsTermsComponent, ApplicationTypeComponent, HomeLoanDetailsComponent, SecurityDetailsComponent, SolicitorPanelDetailsComponent,
      SolicitorBorrowerDetailsComponent, RateComponent, ProductComponent, BrokerNotesComponent, MatProgressSpinnerModule, MatProgressSpinnerModule]
})
export class HomeLoanComponent extends WizardFormComponent implements OnInit, OnDestroy {
  public wizardName = 'Home Loan';
  public baseModel: BaseSubmissionModel;
  public storageIdentifier = 'wiz-home-loan'; // the key for session storage
  public loanPurposeType = 'home-loan';
  public salesRelatesTo = 'home-loan-application-online';
  public blurbText = '';
  public applicationType;
  public isPersonalLoan;
  public isHomeLoan;
  public isPartComplete;
  public subscriptions = [];

  public steps: WizardSteps[] = [
    {
      icon: 'arrow_forward',
      name: 'Application commencement',
      widgets: [
        {name: 'app-originator-broker', class: 'col-sm-12'},
        {name: 'app-application-type', class: 'col-sm-12'},
        {name: 'app-borrower-type-enhanced', class: 'col-sm-12'},
        {
          name: 'app-borrower-type-enhanced-smsf',
          class: 'col-sm-12',
          opts: {label: 'Security Trust', trustType: 'security-trust', trustIndex: 1},
        },
      ],
      classNameStatus: 'default'
    },
    {
      icon: 'arrow_forward',
      name: 'Applicant details',
      widgets: [
        {name: 'app-trust-details', class: 'col-sm-12'},
        {name: 'app-company-details', class: 'col-sm-12'},
        {name: 'app-personal-details', class: 'col-sm-12'},
      ],
      classNameStatus: 'default'
    },
    {
      icon: 'arrow_forward',
      name: 'Income details',
      widgets: [
        {name: 'app-income-details', class: 'col-sm-12'}, // used for company incomes
        {name: 'app-employment-details', class: 'col-sm-12'},
        {name: 'app-investment-income', class: 'col-sm-12', opts: {type: 'home-loan'}},
      ],
      classNameStatus: 'default'
    },
    {
      icon: 'arrow_forward',
      name: 'Assets & Liabilities details',
      widgets: [
        {name: 'app-assets-details', class: 'col-sm-12'},
        {name: 'app-liabilities-details', class: 'col-sm-12'},
        {name: 'app-expenses-details', class: 'col-sm-12'},
      ],
      classNameStatus: 'default'
    },
    {
      icon: 'arrow_forward',
      name: 'Security details',
      widgets: [{name: 'app-security-details', class: 'col-sm-12'}],
      classNameStatus: 'default'
    },
    {
      icon: 'arrow_forward',
      name: 'Loan details',
      widgets: [
        {name: 'app-home-loan-details', class: 'col-sm-12'},
        // { name: 'app-rate', class: 'col-sm-12' },
        {name: 'app-product', class: 'col-sm-12', opts: {type: 'home-loan'}},
      ],
      classNameStatus: 'default'
    },
    {
      icon: 'arrow_forward',
      name: 'Insurance & Legal details',
      widgets: [
        {name: 'app-solicitor-panel-details', class: 'col-sm-12'},
        {name: 'app-solicitor-borrower-details', class: 'col-sm-12'},
      ],
      classNameStatus: 'default'
    },
    {
      icon: 'arrow_forward',
      name: 'Submission',
      widgets: [
        {name: 'app-submit', class: 'col-sm-12'},
        {name: 'app-docs-upload', class: 'col-sm-12'},
        {name: 'app-broker-notes', class: 'col-sm-12'},
      ],
      classNameStatus: 'default'
    },
    {
      icon: 'arrow_forward',
      name: 'Confirmation',
      widgets: [{name: 'app-confirmation', class: 'col-sm-12'}],
      classNameStatus: 'default'
    },
  ];

  constructor(public formBuilderService: FormBuilderService,
              public dataHandlerService: DataHandlerService,
              public submissionService: SubmissionService,
              public applicationService: ApplicationService,
              public notificationService: NotificationService,
              public sanitizer: DomSanitizer,
              public oauthService: OAuthService,
              public router: Router,
              public activatedRoute: ActivatedRoute,
              public workbookService: WorkbookService,
              public typesService: TypesService,
              public communicationService: CommunicationService,
              public salesService: SalesService,
              public productService: ProductService) {
    super(
      formBuilderService,
      dataHandlerService,
      submissionService,
      applicationService,
      notificationService,
      sanitizer,
      oauthService,
      router,
      activatedRoute,
      workbookService,
      typesService,
      communicationService,
      salesService
    );
    console.log('[home-auto]', 'Init Home Loan Application');
    this.dataHandlerService.sendProductCategory('home');
    // this.baseModel = new BusinessAutoModel(this.defaultData);
  }

  setDefaults() {
    this.applicationType = null;
    this.isPersonalLoan = true;
    this.isHomeLoan = true;
    this.isPartComplete = true;
    this.isSMSF = false;
  }

  ngOnInit() {
    super.ngOnInit();
    this.setDefaults();
    // set the details based on the step where they are located
    this.trustDetails = this.getWidget('app-trust-details').get('trustList') as UntypedFormArray;
    this.companyDetails = this.getWidget('app-company-details').get('companyList') as UntypedFormArray;
    this.personalDetails = this.getWidget('app-personal-details').get('personList') as UntypedFormArray;
    this.employmentList = this.getWidget('app-employment-details').get('employmentList') as UntypedFormArray;
    this.companyIncomeList = this.getWidget('app-income-details').get('companyIncomeList') as UntypedFormArray;
    this.trustIncomeList = this.getWidget('app-income-details').get('trustIncomeList') as UntypedFormArray;

    // set the investment form array
    if (
      this.baseform &&
      this.baseform.get('step-2') &&
      this.baseform.get('step-2').get('app-investment-income')
    ) {
      this.investmentFormArray = this.baseform
        .get('step-2')
        .get('app-investment-income')
        .get('investmentList') as UntypedFormArray;
    }

    this.isSMSF = !!(_.some(this.trustDetails.value, v => v.trustType === 'smsf-trust'));

    console.log('home wizard ngOnInit isSMSF', this.isSMSF);
  }

  setProductWatcher() {
    this.subscriptions.push(
      (this.productService.productValidator as any).pipe(debounceTime(300)).subscribe((message) => {
        console.debug('HomeLoanComponent.setProductWatcher');
        if (message) {
          const targetStep = this.steps.findIndex(
            (s) => !!s.widgets.find((w) => w.name === 'app-home-loan-details')
          );
          if (this.latestStep < targetStep) {
            return;
          }
          const navigate = confirm(message as string);
          if (navigate) {
            // force navigate to STEP x
            this.activeStep = targetStep;
            sessionStorage.setItem(this.storageIdentifier + '-step', this.activeStep.toString());
          }
        }
      })
    );
  }

  setSMSFWatcher() {
    // handle hide and showing of SMSF Security Trust
    this.subscriptions.push(
      this.trustDetails.valueChanges.pipe(debounceTime(500)).subscribe((val: any[]) => {
        console.log('setSMSFWatcher', this.isSMSF);

        const wasSMSF = this.isSMSF;
        const isSMSF = _.some(val, (v) => v.trustType === 'smsf-trust');
        if (!isSMSF) {
          this.toggleWidget(false, 'app-borrower-type-enhanced-smsf');
          this.toggleWidget(true, 'app-employment-details');
          this.toggleWidget(true, 'app-expenses-details');

          if (this.trustDetails.at(1)) {
            // remove the second trust
            this.trustDetails.removeAt(1);
          }
          if (this.companyDetails.at(1)) {
            // remove the second company
            this.companyDetails.removeAt(1);
          }
        } else if (isSMSF) {
          this.toggleWidget(true, 'app-borrower-type-enhanced-smsf');
          // const borrowerTypeValue = this.getWidget('app-borrower-type-enhanced').value.borrowerType || null;
          // const smsfBorrowerTypeControl = this.getWidget('app-borrower-type-enhanced-smsf').controls.borrowerType;
          const companyACNControl = this.getWidget('app-borrower-type-enhanced-smsf').controls
            .companyACN;
          const liabilitiesListControl = this.getWidget('app-liabilities-details').controls
            .liabilitiesList as UntypedFormArray;
          // smsfBorrowerTypeControl.setValue(borrowerTypeValue, { emitEvent: false });
          // smsfBorrowerTypeControl.disable({ emitEvent: false });
          companyACNControl.clearValidators();
          companyACNControl.updateValueAndValidity({emitEvent: false});
          if (liabilitiesListControl) {
            liabilitiesListControl.clear();
          }
          this.toggleWidget(true, 'app-employment-details');
          this.toggleWidget(false, 'app-expenses-details');
        }

        if (!isSMSF !== wasSMSF) {
          this.productService.setProductParameters({isSMSF});
        }

        this.isSMSF = isSMSF;

        console.log('setSMSFWatcher', this.isSMSF);

        this.dataHandlerService.sendSmsfData(this.isSMSF);
      })
    );
  }

  ngOnDestroy() {
    console.log('destroying home loan subscriptions', this.subscriptions);
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }

  afterInit() {
    if (
      this.baseform &&
      this.baseform.get('step-1') &&
      this.baseform.get('step-1').get('app-personal-details')
    ) {
      this.personalDetails = this.baseform
        .get('step-1')
        .get('app-personal-details')
        .get('personList') as UntypedFormArray;
    }

    if (
      this.baseform &&
      this.baseform.get('step-1') &&
      this.baseform.get('step-1').get('app-trust-details')
    ) {
      this.trustDetails = this.baseform
        .get('step-1')
        .get('app-trust-details')
        .get('trustList') as UntypedFormArray;
    }

    if (
      this.baseform &&
      this.baseform.get('step-1') &&
      this.baseform.get('step-1').get('app-company-details')
    ) {
      this.companyDetails = this.baseform
        .get('step-1')
        .get('app-company-details')
        .get('companyList') as UntypedFormArray;
    }

    // set the investment form array
    if (
      this.baseform &&
      this.baseform.get('step-3') &&
      this.baseform.get('step-3').get('app-investment-income')
    ) {
      this.investmentFormArray = this.baseform
        .get('step-3')
        .get('app-investment-income')
        .get('investmentList') as UntypedFormArray;
    }

    this.setListValidators();
    this.setSMSFWatcher();
    this.setProductWatcher();
  }

  public getGeneralBlurb() {
    if (this.blurbText === '') {
      return this.sanitizer.bypassSecurityTrustHtml(
        `<div>
        <h5>I confirm</h5>
        <ul>
          <li>The vehicle that is the subject of the application will be used wholly or predominantly for personal use</li>
          <li>The information that I have provided in this loan application is true and correct</li>
          <li>I have read the privacy declaration and consent to Firstmac collecting, using and providing my personal details and credit information to process my loan application in accordance with those terms</li>
        </ul>
        </div>`
      );
    } else {
      return this.sanitizer.bypassSecurityTrustHtml(`${this.blurbText}`);
    }
  }

  setListValidators() {
    this.trustDetails.controls.forEach((fg) => {
      this.formBuilderService.setValidationRules(new IndividualTrustModel(), fg);
    });
    this.companyDetails.controls.forEach((fg) => {
      this.formBuilderService.setValidationRules(new IndividualCompanyModel(), fg);
    });
    this.personalDetails.controls.forEach((fg) => {
      this.formBuilderService.setValidationRules(new IndividualPersonModel(), fg);
    });
  }

  handleApplicationTypeChange(data) {
    // console.log('[handleApplicationTypeChange]', data, this.baseform);
    this.applicationType = data;
    switch (data) {
      case 'continue':
        this.isPersonalLoan = _.isEmpty(this.companyDetails.value);
        break;
      case 'new-personal':
        this.isPersonalLoan = true;
        break;
      default:
        this.isPersonalLoan = false;
        break;
    }
  }

  updateAbnRecord(company) {
    // get ACN
    let _companyACN = '';
    if (
      company['organisation-number-heading'] &&
      company['organisation-number-heading']['_text'] === 'ACN'
    ) {
      _companyACN = company['organisation-number']['_text'];
    }
    // get entity type (needed for borrower type)
    const _entity = {
      ind: company['australian-business-register-report']['EntityTypeInd']
        ? company['australian-business-register-report']['EntityTypeInd']['_text']
        : '',
      text: company['australian-business-register-report']['EntityTypeText']
        ? company['australian-business-register-report']['EntityTypeText']['_text']
        : '',
    };
    // get asic report details (ext)
    const _asic = {
      asicorganisationnumberheadingField: company['australian-business-register-report'][
        'organisation-number-heading'
        ]
        ? company['australian-business-register-report']['organisation-number-heading']['_text']
        : '',
      asicorganisationnumberField: company['australian-business-register-report'][
        'organisation-number'
        ]
        ? company['australian-business-register-report']['organisation-number']['_text']
        : '',
      asicbusinessregistrationnumberField: '',
      aSICNumberField: company['australian-business-register-report']['ASICNumber']
        ? company['australian-business-register-report']['ASICNumber']['_text']
        : '',
      aBNStatusFromDateField: company['australian-business-register-report']['ABNStatusFromDate']
        ? company['australian-business-register-report']['ABNStatusFromDate']['_text']
        : '',
    };
    if (_asic.aBNStatusFromDateField) {
      _asic['aBNStatusFromDateFieldSpecified'] = true;
    } else {
      _asic['aBNStatusFromDateFieldSpecified'] = false;
    }
    // save selected company
    this.selectedCompany = {
      name: company['match-name']._text,
      abn: company['australian-business-number']._text,
      acn: _companyACN,
      entity: _entity,
      asic: _asic,
    };
    this.populateCompanyDetailsFromAbn();
  }

  populateCompanyDetailsFromAbn() {
    if (this.trustDetails.length > 0) {
      this.trustDetails.at(0).patchValue({
        trustName: this.selectedCompany.name,
        trustABN: this.selectedCompany.abn,
        // trustACN: this.selectedCompany.acn,
        ext: this.selectedCompany.asic,
      });
    } else if (this.companyDetails.length > 0) {
      this.companyDetails.at(0).patchValue({
        companyName: this.selectedCompany.name,
        companyABN: this.selectedCompany.abn,
        companyACN: this.selectedCompany.acn,
        ext: this.selectedCompany.asic,
      });
    } else if (this.personalDetails.length > 0) {
      // assuming sole-trader or partnership
      this.personalDetails.at(0).patchValue({
        orgName: this.selectedCompany.name,
        orgABN: this.selectedCompany.abn,
        ext: this.selectedCompany.asic,
        showPersonABN: true,
      });
    }
  }

  handleSelectedTrustCompany(record) {
    if (this.companyDetails.length > 0) {
      // add ext
      const _asic = {
        asicorganisationnumberheadingField: record['australian-business-register-report'][
          'organisation-number-heading'
          ]
          ? record['australian-business-register-report']['organisation-number-heading']['_text']
          : '',
        asicorganisationnumberField: record['australian-business-register-report'][
          'organisation-number'
          ]
          ? record['australian-business-register-report']['organisation-number']['_text']
          : '',
        asicbusinessregistrationnumberField: '',
        aSICNumberField: record['australian-business-register-report']['ASICNumber']
          ? record['australian-business-register-report']['ASICNumber']['_text']
          : '',
        aBNStatusFromDateField: record['australian-business-register-report']['ABNStatusFromDate']
          ? record['australian-business-register-report']['ABNStatusFromDate']['_text']
          : '',
      };
      if (_asic.aBNStatusFromDateField) {
        _asic['aBNStatusFromDateFieldSpecified'] = true;
      } else {
        _asic['aBNStatusFromDateFieldSpecified'] = false;
      }

      this.companyDetails.at(0).patchValue({
        companyName: record['match-name']._text,
        companyABN: record['australian-business-number']._text,
        companyACN: record['organisation-number']['_text'],
        ext: _asic,
      });
    }
  }

  /**
   * Hook into before submit to do form-specific logic
   * @param data
   */
  public formBeforeSubmit(data) {
    // check if session storage has lead
    let lead;
    try {
      lead = JSON.parse(sessionStorage.getItem(this.storageIdentifier + '-lead'));
    } catch {
      console.log('Unable to parse lead from session storage: ' + sessionStorage.getItem(this.storageIdentifier + '-lead'));
      lead = null;
    }

    const packet = super.formBeforeSubmit(data);
    // special interactions for setting of channel / shop / status
    // LCA originator -- 134

    if (!lead || (!lead.shop && !lead.channel)) {
      if (environment.auth.active.source === 'internal') {
        if (packet.parties.find((x) => x.value === LCA_ORIGINATOR_PARTY_ROLE_ID && x.referenceType === 'partyRoleId')) {
          packet.purposes[0].channel = 'retail'; // create retail ontrack account for this person
        }
      }
    }

    packet.lead.source = environment.auth.active.source;
    packet.lead.productCategory = 'home-loan';

    if (!packet.parties.find((x) => x.value === LCA_ORIGINATOR_PARTY_ROLE_ID && x.referenceType === 'partyRoleId')) {
      packet.lead.status = 'live-app';
    } else {
      packet.purposes[0].channel = 'retail';
    }
    return packet;
  }
}
